<template>
  <div id="app">
    <!-- the router outlet, where all matched components would be viewed -->
    <!-- <router-link v-bind:to="'/news'">News</router-link> -->
    <a href="https://www.wowprogress.com/guild/us/frostmourne/Mistake">WoW Progress</a>
    <a href="https://www.twitch.tv/mistakefrostmourne">Streams</a>
    <a href="https://www.youtube.com/channel/UC6iUnSVcrSmAcKyRkGI43Ow">Youtube</a>
    <a href="https://forms.gle/W4vxSfXTtALGmK8a6">Apply Now</a>
    
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Anton&family=Bebas+Neue&display=swap');
#app {
  padding: 5px 10%;
  font-family: "Bebas Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #463f57;
  margin-top: 60px;
  font-weight: normal;
  font-size: 20px;
}
a {
  text-decoration: none;
  color: #463f57;
  font-size: 32px;
  font-weight: bold;
  padding: 10px;
  border-radius: 5px;
}

</style>
